import classNames from "classnames";
import { format } from "date-fns";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { ProgressSpinner } from "primereact/progressspinner";
import { useEffect, useState } from "react";
import { BsExclamationDiamond } from "react-icons/bs";
import { FaTimes } from "react-icons/fa";
import { FaCheck } from "react-icons/fa6";
import { mask } from "remask";
import { Api } from "../../../../services/api";
import { getLocal } from "../../../../utils/localStorageOps";

import { userInfo } from "../../../../services/authHandlers";

export const CancelNegotiation = ({ rowInfo, close, reload, toast }) => {

    const {
        cobranca_id,
        usuario_nome,
        usuario_documento,
        cobranca_descricao,
    } = rowInfo;

    useEffect(() => {
        consultaCobrancasNegociadas();
    }, []);

    const associado_id = getLocal('associado_id');

    const [loading, setLoading] = useState(true);
    const [negociacaoData, setNegociacaoData] = useState([]);
    const [loadButton, setLoadButton] = useState(true);

    const [viewQuebra, setViewQuebra] = useState(false);

    const verificaCancelamento = async () => {
        const existeBoleto = negociacaoData.boletos.filter(boleto => boleto.boleto_status === 'Pago').length > 0
        if (existeBoleto) {
            // console.log('existe boleto')
            setViewQuebra((prev) => !prev)
        }
        else {
            // console.log('não existe boleto')
            negociacaoCancela();
        }
    }

    const negociacaoCancela = async () => {
        try {
            setLoadButton(true)
            const associado_operador_id = userInfo.associado_id || associado_id
            await Api.patch(`genericnegotiation/cancela/${cobranca_id}`, {
                associado_id: associado_operador_id
            });
            toast('success', 'Negociação Cancelada.');
            reload();
            close();
        } catch (error) {
            console.error(error);
            if (error.response && error.response.status === 403)
                toast('error', error.response.data);
        } finally {
            setLoadButton(false)
        }
    };

    const quebraNegociacao = async () => {
        try {
            setLoadButton(true)
            const associado_operador_id = userInfo.associado_id || associado_id
            await Api.post(`quebranegociacao/executar/${cobranca_id}`, {
                associado_id: associado_operador_id
            });
            toast('success', 'Negociação Quebrada.');
            reload();
            close();
        } catch (error) {
            console.error(error);
            if (error.response && error.response.status === 403)
                toast('error', error.response.data);
        } finally {
            setLoadButton(false)
        }
    };

    const consultaCobrancasNegociadas = async () => {
        try {
            setLoading(true);
            setLoadButton(true);
            const { data } = await Api.get(`/cobranca/consulta-cobrancas-negociadas/${cobranca_id}`);
            setNegociacaoData(data)
            // console.log(data);
        } catch (err) {
            console.error(err);
        } finally {
            setLoadButton(false)
            setLoading(false);
        }
    };

    const footerCancela = (
        <div className="flex justify-around w-full">
            <div className="w-1/3" >
                <Button
                    severity="info"
                    style={{ width: '100%' }}
                    label="Sim"
                    loading={loadButton}
                    icon={<FaCheck className="text-3xl" />}
                    onClick={() => { verificaCancelamento() }}
                />
            </div>
            <div className="w-1/3" >
                <Button
                    severity="danger"
                    style={{ width: '100%' }}
                    label="Não"
                    loading={loadButton}
                    icon={<FaTimes className="text-3xl" />}
                    onClick={() => { close() }}
                />
            </div>
        </div>)

    const footerQuebra = (
        <div className="flex justify-around w-full">
            <div className="w-1/3" >
                <Button
                    severity="info"
                    style={{ width: '100%' }}
                    label="Sim"
                    loading={loadButton}
                    icon={<FaCheck className="text-3xl" />}
                    onClick={() => { quebraNegociacao() }}
                />
            </div>
            <div className="w-1/3" >
                <Button
                    severity="danger"
                    style={{ width: '100%' }}
                    label="Não"
                    loading={loadButton}
                    icon={<FaTimes className="text-3xl" />}
                    onClick={() => { setViewQuebra((prev) => !prev) }}
                />
            </div>
        </div>)

    return (
        <div>
            <Dialog
                visible={viewQuebra}
                header={`Tem certeza de que deseja Quebrar a Negociação?`}
                pt={{
                    root: 'w-[60vw] md:w-[30vw] h-auto ',
                    header: classNames('flex items-center justify-between shrink-0',
                        'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
                        'dark:bg-gray-900  dark:text-white/80'),
                }}
                onHide={() => { setViewQuebra((prev) => !prev) }}
                footer={footerQuebra}
            >
                <div className="flex justify-center m-0">
                    <h5>
                        Esta negociação não pode ser cancelada pois já possui boletos pagos. <br />
                        O Acordo será quebrado, reajustando o valor e criando uma nova cobrança com o valor remanescente.
                    </h5>
                </div>
            </Dialog>

            <Dialog
                visible
                header={`Tem certeza que deseja cancelar a negociação?`}
                pt={{
                    root: 'w-[80vw] md:w-[50vw] h-auto ',
                    header: classNames('flex items-center justify-between shrink-0',
                        'bg-white text-gray-800 border-t-0  rounded-tl-lg rounded-tr-lg p-6',
                        'dark:bg-gray-900  dark:text-white/80'),
                }}
                onHide={() => close()}
                footer={footerCancela}
            >
                <div className="flex items-center">
                    {!loading ?
                        <div className="flex items-center">
                            <div className="w-full md:w-7/12 mt-4 ml-2 text-xl">
                                <h5><b>*Só é possível cancelar negociações que não possuam boletos pagos</b></h5>
                                <h5><b>Nome: </b>{usuario_nome}</h5>
                                <h5><b>Documento: </b>{mask(usuario_documento, ['999.999.999-99', '99.999.999/9999-99'])}</h5>
                                <h5><b>Descrição: </b>{cobranca_descricao}</h5>
                                <h5><b>Data de vencimento do próximo boleto: </b>{negociacaoData.boletos.length > 0 && format(negociacaoData.boletos.filter(boleto => boleto.boleto_status === 'Não Pago')[0].cobranca_data_vencimento, 'dd/MM/yyyy')}</h5>
                                <h5><b>Boletos Pagos:</b> {negociacaoData.boletos.length > 0 && negociacaoData.boletos.filter(boleto => boleto.boleto_status === 'Pago').length}/{negociacaoData.boletos.length}</h5>
                            </div>
                            <div className="w-full md:w-4/12 flex justify-center items-center">
                                <BsExclamationDiamond
                                    style={{ textAlign: "center", color: "crimson", fontSize: '10rem' }}
                                />
                            </div>
                        </div>
                        :
                        <ProgressSpinner strokeWidth="8" />
                    }
                </div>
            </Dialog>
        </div>
    )
}